import React from "react";

import { Box } from "@mui/material";

import EllipsisText from "components/EllipsisText";
import { GenericTableColumn } from "components/organisms/GenericTable/GenericTable.types";

import DescriptionCell from "./components/DescriptionCell";

type CreateColumnsArgs = {
    language?: any;
};

const CELL_FONT_SIZE = 14;

export const createActivityLogColumns = ({
    language,
}: CreateColumnsArgs): GenericTableColumn[] => [
    {
        key: "id",
        header: language?.sources_page?.logID ?? "Log ID",
        label: language?.sources_page?.logID ?? "Log ID",
        fixedWidth: 100,
        render: (row) => (
            <Box sx={{ minWidth: 0, fontSize: CELL_FONT_SIZE }}>
                <EllipsisText text={String(row.id ?? "—")} width="100%" />
            </Box>
        ),
    },
    {
        key: "user",
        header: language?.sources_page?.user ?? "User",
        label: language?.sources_page?.user ?? "User",
        width: 1.5,
        minWidth: 130,
        render: (row) => (
            <Box sx={{ minWidth: 0 }}>
                <Box
                    sx={{
                        fontFamily: "Nunito, sans-serif",
                        fontSize: CELL_FONT_SIZE,
                        fontWeight: 700,
                        color: "#1a1a1a",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }}
                >
                    {row?.user?.name ?? "—"}
                </Box>
                <Box
                    sx={{
                        fontFamily: "Nunito, sans-serif",
                        fontSize: CELL_FONT_SIZE,
                        color: "#999",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }}
                >
                    {row?.user?.id ?? ""}
                </Box>
            </Box>
        ),
    },
    {
        key: "description",
        header: language?.sources_page?.description ?? "Description",
        label: language?.sources_page?.description ?? "Description",
        width: 3,
        minWidth: 200,
        render: (row) => (
            <DescriptionCell description={row.description} model={row.model} />
        ),
    },
    {
        key: "created_at",
        header: language?.sources_page?.date_and_time ?? "Date and Time",
        label: language?.sources_page?.date_and_time ?? "Date and Time",
        fixedWidth: 210,
        render: (row) => (
            <Box sx={{ minWidth: 0, fontSize: CELL_FONT_SIZE }}>
                <EllipsisText text={row.created_at || "—"} width="100%" />
            </Box>
        ),
    },
];
